import { resolvePremiumExpiration } from './resolve-premium-expiration';

/**
 * Resolves premium status from user data, checking both subscription and premiumAccessUntil
 * @param {Object} userData - User document data from Firestore
 * @returns {Object} { isPremium: boolean, expiresAt: number|null, source: 'subscription'|'daily_pass'|null }
 */
export function resolvePremiumStatus(userData) {
  if (!userData) {
    return { isPremium: false, expiresAt: null, source: null };
  }

  // Check subscription status first
  const subscription = userData.subscription;
  if (subscription && subscription.status === 'active') {
    const periodEnd = subscription.currentPeriodEnd;
    if (periodEnd) {
      const expiresAt = typeof periodEnd.toMillis === 'function' 
        ? periodEnd.toMillis()
        : typeof periodEnd.toDate === 'function'
        ? periodEnd.toDate().getTime()
        : typeof periodEnd === 'number'
        ? periodEnd * 1000
        : null;
      
      if (expiresAt && expiresAt > Date.now()) {
        return {
          isPremium: true,
          expiresAt,
          source: 'subscription',
          subscription,
        };
      }
    }
  }

  // Check daily pass (premiumAccessUntil)
  const expiresAt = resolvePremiumExpiration(userData.premiumAccessUntil);
  if (expiresAt && expiresAt > Date.now()) {
    return {
      isPremium: true,
      expiresAt,
      source: 'daily_pass',
    };
  }

  return {
    isPremium: false,
    expiresAt: expiresAt || null,
    source: null,
  };
}
